const levelIndicatorsSimple = (data) => {
  return `
  WITH t as (

    SELECT ${data.agg}(INDICATOR_values.value) AS indicator_total,
      (SELECT id_${data.nivel} FROM geo_def WHERE cartodb_id=indicator_values.geo_id) AS father_id
    FROM indicator_values
    WHERE indicator_id = ${data.id}
      AND datetime >= to_timestamp('${data.start_date}', 'YYYY-MM-DD HH24:MI:SS')
      AND datetime <= to_timestamp('${data.end_date}', 'YYYY-MM-DD HH24:MI:SS')
    GROUP BY INDICATOR_values.geo_id
  
  ), j as (
  
    SELECT geo_def.cartodb_id,
      geo_def.name AS name,
      (SELECT ROUND(${data.geo_agg}(indicator_total)::numeric, ${data.decimals}) FROM t WHERE father_id = cartodb_id GROUP BY father_id LIMIT 1) as total,
      to_timestamp('${data.datetime}', 'YYYY-MM-DD HH24:MI:SS') AS stamp
    FROM geo_def
    WHERE nivel = ${data.nivel}
  
  )
  
  SELECT j.*, k.name as local_name
  FROM j
  JOIN GEOLOCALIZATION_TRANSLATIONS k ON k.geolocalization_id=j.cartodb_id
  WHERE j.total IS NOT NULL AND k.locale='${data.lang}'
  
  `;
};

export default levelIndicatorsSimple;
